import { render } from "./InfoNew.vue?vue&type=template&id=62dd95d7&scoped=true"
import script from "./InfoNew.vue?vue&type=script&lang=js"
export * from "./InfoNew.vue?vue&type=script&lang=js"

import "./InfoNew.vue?vue&type=style&index=0&id=62dd95d7&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dd95d7"]])

export default __exports__